import React from 'react';
import propTypes from 'prop-types';
import CenterToolbarComponent from '../../UI/Toolbar/CenterToolbar';
import CenterToolbarItems from '../ToolbarItems';

const CenterToolbar = ({
  centerList,
  pathname,
  isTop,
  formatType,
  appType,
  LinkComponent,
}) => {
  return (
    <CenterToolbarComponent pathname={pathname} formatType={formatType}>
      <CenterToolbarItems
        list={centerList}
        pathname={pathname}
        isTop={isTop}
        formatType={formatType}
        appType={appType}
        LinkComponent={LinkComponent}
      />
    </CenterToolbarComponent>
  );
};

CenterToolbar.propTypes = {
  centerList: propTypes.objectOf(
    propTypes.oneOf([propTypes.string, propTypes.object]),
  ).isRequired,
  isTop: propTypes.bool.isRequired,
  pathname: propTypes.string.isRequired,
};

export default CenterToolbar;
